import React from "react";

import { Slot, type Slottable } from "~/components/slot";
import { cv } from "~/tools/class-variance";

import styles from "./_join.module.css";

const variants = cv(styles.join, {
	variants: {
		direction: {
			vertical: styles.vertical,
			horizontal: styles.horizontal,
		},
	},
	defaultVariants: {
		direction: "horizontal",
	},
});

export interface JoinProps extends Slottable, React.HTMLAttributes<HTMLElement> {
	/**
	 * @default "horizontal"
	 */
	direction?: "vertical" | "horizontal";
}

export const Join = React.forwardRef<HTMLDivElement, JoinProps>(
	({ asChild = false, direction = "horizontal", className, ...props }, ref) => {
		const Component = asChild ? Slot : "div";

		return <Component className={variants({ direction, className })} ref={ref} {...props} />;
	},
);

if (import.meta.env.DEV) {
	Join.displayName = "Join";
}
